import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../translations/en.json";
import hi from "../translations/hi.json";
import bn from "../translations/bn.json";
import homeEn from "../translations/home/en.json";
import homeHi from "../translations/home/hi.json";
import homeHinglish from "../translations/home/hi-Latn.json";
import shopEn from "../translations/shop/en.json";
import shopHi from "../translations/shop/hi.json";
import shopHinglish from "../translations/shop/hi-Latn.json";

// Languages offered in the website's language switcher.
// "hi-Latn" is Hinglish: Hindi written in English letters.
export const SUPPORTED_LANGUAGES = ["en", "hi", "hi-Latn"];

const STORAGE_KEY = "tod_language";

// ?lang= in the URL, e.g. https://theovendelights.in/?lang=hi
// Accepts a few spellings; Hinglish is written as "hinglish" in links.
export const LANGUAGE_URL_PARAM = "lang";
const URL_ALIASES = {
  en: "en",
  english: "en",
  hi: "hi",
  hindi: "hi",
  "hi-latn": "hi-Latn",
  hinglish: "hi-Latn",
};
export const LANGUAGE_URL_VALUES = {
  en: "en",
  hi: "hi",
  "hi-Latn": "hinglish",
};

export function languageFromUrl(search = window.location.search) {
  try {
    const value = new URLSearchParams(search).get(LANGUAGE_URL_PARAM);
    return (value && URL_ALIASES[value.trim().toLowerCase()]) || null;
  } catch (e) {
    return null;
  }
}

const resources = {
  en: {
    translation: en,
    home: homeEn,
    shop: shopEn,
  },
  hi: {
    translation: hi,
    home: homeHi,
    shop: shopHi,
  },
  "hi-Latn": {
    home: homeHinglish,
    shop: shopHinglish,
  },
  bn: {
    translation: bn,
  },
};

function readSavedLanguage() {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return SUPPORTED_LANGUAGES.includes(saved) ? saved : null;
  } catch (e) {
    return null;
  }
}

// The link wins, then the visitor's last choice, then English.
const initialLanguage = languageFromUrl() || readSavedLanguage() || "en";

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: "en",
  // Only look up the exact language, so Hinglish ("hi-Latn") never falls
  // back to Devanagari Hindi before English.
  load: "currentOnly",
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

function syncDocumentLanguage(lng) {
  document.documentElement.lang = lng;
  try {
    window.localStorage.setItem(STORAGE_KEY, lng);
  } catch (e) {
    // storage can be unavailable (private mode); the switch still works for this visit
  }
}

// Keep ?lang= in the address bar in step with the switcher, so a copied link
// opens in the same language. Only replaces the entry; no extra history.
function syncUrlLanguage(lng) {
  try {
    const url = new URL(window.location.href);
    const value = LANGUAGE_URL_VALUES[lng];
    if (!value || url.searchParams.get(LANGUAGE_URL_PARAM) === value) return;
    url.searchParams.set(LANGUAGE_URL_PARAM, value);
    window.history.replaceState(window.history.state, "", url.toString());
  } catch (e) {
    // ignore: the language still changes on the page
  }
}

syncDocumentLanguage(i18n.language);
i18n.on("languageChanged", (lng) => {
  syncDocumentLanguage(lng);
  syncUrlLanguage(lng);
});

export default i18n;
